import React, { useEffect, useState } from "react";
import AddToList from "./AddToList";
import { useTranslation } from "react-i18next";
import { lang } from "../../lang";


const ApplicantsAvailability = (props) => {
  const [ln,setLn] = useState('en')
  // const [slot, setSlot] = useState("")
  // const [addtolistPop, setAddtolistPop] = useState(false)
  const [availabilityData, setAvailanilityData] = useState()
  // const [fridayTimeing, setFridayTiming] = useState()
  // const [saturdayTimeing, setSaturdayTiming] = useState()
  // const [sundayTimeing, setSundayTiming] = useState()
  // const [mondayTimeing, setMondayTiming] = useState()
  // const [tuesdayTimeing, setTuesdayTiming] = useState()
  // const [wednesdayTimeing, setWednesdayTiming] = useState()
  // const [thursdayTimeing, setThursdayTiming] = useState()

  



  
  // const searchItem = props?.searchItem
  // console.log('searchEvent', searchItem)
  const candidateData = props?.Candidate || props?.recommendedCandidateData ||  props?.unlockedUserData || props?.searchItem || props?.single_applicants_details
  // const candidateData =  props?.single_applicants_details
  const updateValue = props?.Candidate || props?.recommendedCandidateData ||  props?.unlockedUserData || props?.searchItem || props?.single_applicants_details
  const candidateDatas = updateValue.part_time_availability.map(obj => ({ ...obj, isOpen: false }));
  const [listValu,setListValu] = useState(candidateDatas)

  // const unlockedUser =
  // console.log('unlockedUser', unlockedUser)

  const getCandidateData = ()=>{
    setAvailanilityData(candidateData )
  }


  console.log(candidateDatas,'candidateData', candidateData)

  console.log('availabilityData', availabilityData)

  

const splitSize = 2;

  const { t } = useTranslation();

// -----------------------------Friday----------------------------
const fridaay = availabilityData?.part_time_availability[0]?.friday

console.log("fridaaaay", fridaay)

const friday = [(availabilityData?.part_time_availability[0]?.friday)?.split(',')]
friday[0]?.forEach((item, index, arr)=>
arr[index] = (`${item/2}`)?.replace('.5', ':30')
)
console.log('friday', friday)
const spiltFridayTimeIntoArray = (arr, arrSize) => {
    const result = []
    for(let i=0; i < arr?.length; i=i+arrSize){
        result?.push(arr?.slice(i, i+arrSize))
        // setFridayTiming(result)
    }
    return result
}
const fridaytime = spiltFridayTimeIntoArray(friday[0], splitSize)
console.log('fridaytime', fridaytime)
// console.log('spiltTimeIntoArray', spiltFridayTimeIntoArray(friday[0], splitSize))

// -----------------------Saturday---------------------------
const saturday = [(availabilityData?.part_time_availability[0]?.saturday)?.split(',')]
saturday[0]?.forEach((item, index, arr)=>
arr[index] = (`${item/2}`)?.replace('.5', ':30')
)
console.log('saturday', saturday)
const spiltSaturdayTimeIntoArray = (arr, arrSize) => {
    const result = []
    for(let i=0; i < arr?.length; i=i+arrSize){
        result?.push(arr?.slice(i, i+arrSize))
    }
    return result
}

const saturdaytime = spiltSaturdayTimeIntoArray(saturday[0], splitSize)
console.log('saturdaytime', saturdaytime)

// -----------------------Sunday---------------------------
const sunday = [(availabilityData?.part_time_availability[0]?.sunday)?.split(',')]
sunday[0]?.forEach((item, index, arr)=>
arr[index] = (`${item/2}`)?.replace('.5', ':30')
)
console.log('sunday', sunday)
const spiltSundayTimeIntoArray = (arr, arrSize) => {
    const result = []
    for(let i=0; i < arr?.length; i=i+arrSize){
        result?.push(arr?.slice(i, i+arrSize))
    }
    return result
}

const sundaytime = spiltSundayTimeIntoArray(sunday[0], splitSize)
console.log('sundaytime', sundaytime)


// -----------------------Monday---------------------------
const monday = [(availabilityData?.part_time_availability[0]?.monday)?.split(',')]
monday[0]?.forEach((item, index, arr)=>
arr[index] = (`${item/2}`)?.replace('.5', ':30')
)
console.log('monday', monday)
const spiltMondayTimeIntoArray = (arr, arrSize) => {
    const result = []
    for(let i=0; i < arr?.length; i=i+arrSize){
        result?.push(arr?.slice(i, i+arrSize))
    }
    return result
}

const mondaytime = spiltMondayTimeIntoArray(monday[0], splitSize)
console.log('mondaytime', mondaytime)

// -----------------------Tuesday---------------------------
const tuesday = [(availabilityData?.part_time_availability[0]?.tuesday)?.split(',')]
tuesday[0]?.forEach((item, index, arr)=>
arr[index] = (`${item/2}`)?.replace('.5', ':30')
)
console.log('tuesday', tuesday)
const spiltTuesdayTimeIntoArray = (arr, arrSize) => {
    const result = []
    for(let i=0; i < arr?.length; i=i+arrSize){
        result?.push(arr?.slice(i, i+arrSize))
    }
    return result
}

const tuesdaytime = spiltTuesdayTimeIntoArray(tuesday[0], splitSize)
console.log('tuesdaytime', tuesdaytime)

// -----------------------Wednesday---------------------------
const wednesday = [(availabilityData?.part_time_availability[0]?.wednesday)?.split(',')]
wednesday[0]?.forEach((item, index, arr)=>
arr[index] = (`${item/2}`)?.replace('.5', ':30')
)
console.log('wednesday', wednesday)
const spiltWednesdayTimeIntoArray = (arr, arrSize) => {
    const result = []
    for(let i=0; i < arr?.length; i=i+arrSize){
        result?.push(arr?.slice(i, i+arrSize))
    }
    return result
}

const wednesdaytime = spiltWednesdayTimeIntoArray(wednesday[0], splitSize)
console.log('wednesdaytime', wednesdaytime)



// -----------------------Thursday---------------------------
const thursday = [(availabilityData?.part_time_availability[0]?.thursday)?.split(',')]
thursday[0]?.forEach((item, index, arr)=>
arr[index] = (`${item/2}`)?.replace('.5', ':30')
)
console.log('thursday', thursday, availabilityData?.part_time_availability[0]?.thursday)

const spiltThursdayTimeIntoArray = (arr, arrSize) => {
    const result = []
    for(let i=0; i < arr?.length; i=i+arrSize){
        result?.push(arr?.slice(i, i+arrSize))
    }
    return result
}

const thursdaytime = spiltThursdayTimeIntoArray(thursday[0], splitSize)
console.log('thursdaytime', thursdaytime)

useEffect(()=>{
  if(localStorage.getItem("language") != null){
    setLn(localStorage.getItem("language"))
  }
},[])

useEffect(()=>{
  getCandidateData()
  spiltMondayTimeIntoArray(monday[0], splitSize)
  spiltTuesdayTimeIntoArray(tuesday[0], splitSize)
  spiltWednesdayTimeIntoArray(wednesday[0], splitSize)
  spiltThursdayTimeIntoArray(thursday[0], splitSize)
  spiltFridayTimeIntoArray(friday[0], splitSize)
  spiltSaturdayTimeIntoArray(saturday[0], splitSize)
  spiltSundayTimeIntoArray(sunday[0], splitSize)
},[])






  return (
    <div className="applicants-availability">
      <div className="row"> 
        <div className="">
          <p className="popup-heading my-3" style={{display:"flex" , justifyContent:"center"}}>{listValu == [] ?t('Availability for Part Time'):lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth['Not Availability for Part Time']:""} </p>

          
      {
        listValu?.map((it)=>{
          return(
            <div className="available-box "     style={{cursor: "pointer"}}
            onClick={() =>{
              let valu = listValu.map((res)=>{
                if(res.day == it.day){
                  res.isOpen = !res.isOpen
                }
                return{... res}
              })
              console.log("val",valu)
              setListValu(valu)
            }}>
      <div className="space-between d-flex">
        <p className="available-day">{t(it.day)}</p>
        <p className="availavle-slots">
          ({(it.timesloteArr.length !== 0)? it.timesloteArr.length: 0} {t('slots Available')}){" "}
          <img
            src="../images/toggle-down.png"
        
            className="ml-2"
          />{" "}
        </p>
      </div>
      
      {(it.timesloteArr.length !== 0) &&
      <>
      {it.isOpen == true ? (
        <>
          <p className="text font-weight-light">
            {t('All times are in your local time')} (PST)
          </p>

          <div className="mt-2 d-flex flex-column animation">
            {it.timesloteArr?.map((item, index)=>{
              const time1 = item.open
              const time2 = item.close
              return (
            <span className="slot-time-box" key={index}> {time1?.length >2 ? time1 : `${time1}:00`} - {time2?.length > 2 ? time2 : `${time2}:00`}</span>
              )
            })
            }
            {/* <span className="slot-time-box">11.00AM - 01:00PM</span>
            <span className="slot-time-box">11.00AM - 01:00PM</span> */}
          </div>
        </>
      ) : null}
      </>
      }
      
          
    </div>
          )
        })
      }

         
        </div>
        {/* <div className="col-2 flex-column pl-0">
          <div className=" flex-column sticky-top pt-3">
            <div className="white-circle flex-center flex-column">
              <p className="font-12">{searchItem?.percentage_match}</p>
              <p className="font-8">Match</p>
            </div>
            <div className="white-circle flex-center">
              <img src="./images/bookmark.png" alt="" />
            </div>
            <div className="white-circle flex-center" onClick={(e)=>{
              e.stopPropagation()
              setAddtolistPop(true)
            }}>
              <img src="./images/send-job.png" alt="" />
            </div>
            {addtolistPop && <AddToList setAddtolistPop={setAddtolistPop} />}

            <div className="white-circle flex-center">
              <img src="./images/share-icon.png" alt="" />
            </div>

            <div className="blue-circle flex-center">
              <img src="./images/unlcoked-profile-white.png" alt="" />
            </div>
            <div className="red-circle flex-center" onClick={props.closePopup}>
              <img src="./images/cross.png" alt="" />
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default ApplicantsAvailability;
